/*
 *
 * Selectors for PayBalance
 *
 */

import { createSelector } from 'reselect';
import { utils } from '../../devUtils';

const selectPayBalanceDomain = (state) => state.get('payBalance');
const selectPayBalance = () => createSelector(
  selectPayBalanceDomain,
  (PayBalance) => PayBalance,
);
const select_total_balance = () => createSelector(
  selectPayBalanceDomain,
  (PayBalance) => PayBalance.get('total_balance'),
);
const select_zaggle_cash = () => createSelector(
  selectPayBalanceDomain,
  (PayBalance) => PayBalance.get('zaggle_cash'),
);
const select_yscs = () => createSelector(
  selectPayBalanceDomain,
  (PayBalance) => PayBalance.get('yscs').toJS(),
);
const select_zscs = () => createSelector(
  selectPayBalanceDomain,
  (PayBalance) => PayBalance.get('zscs').toJS(),
);
const select_add_card = () => createSelector(
  selectPayBalanceDomain,
  (PayBalance) => PayBalance.get('add_card_obj').toJS(),
);
const select_otp_response = (key) => createSelector(
  selectPayBalanceDomain,
  (PayBalance) => utils.immutableToJS(PayBalance.get(key)),
);

const isLoading = () => createSelector(
  selectPayBalanceDomain,
  (PayBalance) => PayBalance.get('isLoading'),
);

const select_PayBalanceJS = (key) => createSelector(
  selectPayBalanceDomain,
  (PayBalance) => PayBalance.get(key).toJS(),
);

const select_xml_m2p_kyc = () => createSelector(
  selectPayBalanceDomain,
  (PayBalance) => PayBalance.get('xml_m2p_kyc').toJS(),
);

const select_has_indusind_card = () => createSelector(
  selectPayBalanceDomain,
  (PayBalance) => PayBalance.get('has_indusind_card'),
);

const select_min_kyc_required = () => createSelector(
  selectPayBalanceDomain,
  (PayBalance) => PayBalance.get('min_kyc_required'),
);

const select_generateOtpYsc = () => createSelector(
  selectPayBalanceDomain,
  (PayBalance) => PayBalance.get('generate_Otp_Ysc').toJS(),
);

const select_ybl_otp_success = () => createSelector(
  selectPayBalanceDomain,
  (PayBalance) => PayBalance.get('ybl_otp_success').toJS(),
);

const select_ybl_otp_verified = () => createSelector(
  selectPayBalanceDomain,
  (PayBalance) => PayBalance.get('ybl_otp_verified').toJS(),
);

const select_ybl_min_kyc = (key) => createSelector(
  selectPayBalanceDomain,
  (PayBalance) => PayBalance.get(key).toJS(),
);

const select_ybl_min_kyc_existing_users = (key) => createSelector(
  selectPayBalanceDomain,
  (PayBalance) => PayBalance.get(key).toJS(),
);

export {
  selectPayBalance, select_zaggle_cash, select_total_balance, select_yscs, select_zscs, select_add_card, select_otp_response, isLoading,
  select_PayBalanceJS, select_xml_m2p_kyc, select_has_indusind_card, select_generateOtpYsc, select_ybl_otp_success, select_ybl_otp_verified, select_ybl_min_kyc,
  select_ybl_min_kyc_existing_users, select_min_kyc_required,
};



// WEBPACK FOOTER //
// client/containers/PayBalance/selectors.js